import React, { useEffect } from "react";
import MainCard from "components/MainCard";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { Grid, Button, Tooltip } from "@mui/material";
import { Modal, Form, Input, Checkbox } from "antd";
import { toast } from "react-toastify";
import { useState } from "react";
import TextRichEditor from "components/text-rich-editor/TextRichEditor";
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { dispatch } from "store/index";
import { AddEmailTemplate, EditEmailTemplate } from "store/action/index";
import { FaRegLightbulb } from "react-icons/fa";
import * as url from "../../store/constant/Endpoints";
import HTMLRenderer from "helper/htmlreader";

const CreateEditEmailTemplate = ({ children, setLoading, data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [editorValue, setEditorValue] = useState(data?.body || "");
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store uploaded files
  const [fileList, setFileList] = useState([])
  const [newpayloadfileList, setNewPayloadFileList] = useState([])
  const [isRichEditor, setIsRichEditor] = useState(false);
  const [editCond, setEditCond] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false)
  let params = { team_id: localStorage.getItem("teams_id") }

  const showModal = () => {
    setIsModalOpen(true);
    if (data) {
      setEditCond(true)
      form.setFieldsValue({
        templateName: data?.name,
        subject: data?.subject,
        body: data?.body,
        footer: data?.footer,
      });
      setEditorValue(data?.body);

      // ✅ Existing attachments ko parse karke fileList set karo
      if (data?.attachment) {
        const parsedAttachments = JSON.parse(data?.attachment).map((file, index) => ({
          uid: index.toString(),
          name: file.split('/').pop(), // Filename extract karo
          url: `${url.base_url_blank_document}${file}`, // ✅ BASE_URL add karo
          status: 'done',
        }));
        const parsedAttachmentsSend = JSON.parse(data?.attachment).map((file, index) => ({
          uid: index.toString(),
          name: file.split('/').pop(), // Filename extract karo
          url: `${file}`, // ✅ BASE_URL add karo
          status: 'done',
        }));
        setFileList(parsedAttachments);
        setNewPayloadFileList(parsedAttachmentsSend)
      }
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const payload = {
          ...(data && { id: data?.id, _method: "PUT" }),
          name: values.templateName,
          subject: values.subject,
          attachments: uploadedFiles,
          all_attachment: (newpayloadfileList || []).map(file => file?.url || ""),
          body: isRichEditor ? editorValue : form.getFieldValue("body"),
          footer: values.footer,
        };
        setLoadingBtn(true)
        if (data) {
          dispatch(EditEmailTemplate({ payload, setLoading, setLoadingBtn: setLoadingBtn, params }));
        } else {
          dispatch(AddEmailTemplate({ payload, setLoading, setLoadingBtn: setLoadingBtn, params }));
        }

        form.resetFields();
        setEditorValue("");
        handleCancel();
      })
      .catch(() => {
        toast.error("Please fill out all required fields", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          bodyClassName: "toastStyle",
        });
      });
  };

  const toggleEditor = (checked) => {
    setIsRichEditor(checked);
    console.log( form.getFieldValue("body") , "editorValue")
    if (checked) {
      setEditorValue(editorValue);
    } else {
      form.setFieldsValue({ body: form.getFieldValue("body") });
    }
  };

  const handleImageUpload = async (file, onSuccess, onError) => {
    try {
      const newFile = {
        uid: file.uid,
        name: file.name,
        url: URL.createObjectURL(file), // Temporary preview ke liye
        status: 'done'
      };

      setUploadedFiles((prev) => [...prev, file]); // ✅ Naye files store karna
      setFileList((prev) => [...prev, newFile]); // ✅ File list update karna

      onSuccess();
    } catch (error) {
      onError(error);
    }
  };

  const handleRemoveFile = (file) => {
    setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
    setNewPayloadFileList((prev) => prev.filter((item) => item.uid !== file.uid));
  };


  return (
    <>
      <span onClick={showModal}>{children}</span>
      <Modal
        title={data ? "Update Email Template" : "Add Email Template"}
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        centered
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            templateName: data?.name || "",
            subject: data?.subject || "",
            body: data?.body || "",
            footer: data?.footer || "",
          }}
          style={{ maxHeight: "70vh", overflowY: "auto" }}
          zIndex={1000}
        >
          <Form.Item
            label="Template Name"
            name="templateName"
            rules={[{ required: true, message: "Template Name is required" }]}
          >
            <Input placeholder="Enter template name" />
          </Form.Item>

          <Form.Item
            label="Subject"
            name="subject"
            rules={[{ required: true, message: "Subject is required" }]}
          >
            <Input placeholder="Enter subject" />
          </Form.Item>

          <Form.Item name="Attachment" label="Attachment">
            <Upload
              customRequest={({ file, onSuccess, onError }) =>
                handleImageUpload(file, onSuccess, onError)
              }
              listType="text"
              fileList={fileList} // ✅ File list set kiya
              maxCount={editCond ? 3 - newpayloadfileList.length : 3}
              multiple
              onPreview={(file) => {
                window.open(file.url, "_blank"); // ✅ Open correct file
              }}
              onRemove={handleRemoveFile} // ✅ File delete karne ka function
              beforeUpload={(file) => {
                if (fileList.length >= 3) {
                  Modal.error({
                    title: "Upload Limit Reached",
                    content: "You can only upload up to 3 files.",
                  });
                  return Upload.LIST_IGNORE;
                }

                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!isLt5M) {
                  Modal.error({
                    title: "File Size Exceeded",
                    content: "Each file must be less than 5MB.",
                  });
                  return Upload.LIST_IGNORE;
                }

                const fileExtension = file.name.split(".").pop().toLowerCase();
                const allowedExtensions = ["pdf", "doc", "docx", "xls", "xlsx", "csv", "txt", "ppt", "pptx", "png", "jpg", "jpeg"];
                if (!allowedExtensions.includes(fileExtension)) {
                  Modal.error({
                    title: "Invalid File Type",
                    content: "Only document files and images are allowed.",
                  });
                  return Upload.LIST_IGNORE;
                }

                return true;
              }}

            >
              <Button style={{ backgroundColor: "#cadaf7" }} icon={<UploadOutlined />}>
                Upload Attachments (Max 3 Files)
              </Button>
            </Upload>
          </Form.Item>


          <Form.Item style={{ marginBottom: "5px", marginLeft: "3px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div>
                <Checkbox
                  checked={isRichEditor}
                  onChange={(e) => toggleEditor(e.target.checked)}
                >
                  Use Rich Text Editor
                </Checkbox>
              </div>
              <div style={{ marginLeft: "25px" }}>
                <Tooltip title="To include the lead's name, use curly braces like {name}. in the Body field">
                  <span>
                    <FaRegLightbulb size={18} color="#ffa726" />
                  </span>
                </Tooltip>
              </div>
            </div>
          </Form.Item>

          <Form.Item
            label="Body"
            name="bodys"
            rules={[
              {
                // required: true,
                // validator: () => {
                //   if (!isRichEditor) {
                //     const htmlValue = form.getFieldValue("body");
                //     return !htmlValue
                //       ? Promise.reject("Body is required")
                //       : Promise.resolve();
                //   } else {
                //     return editorValue == "<p> </p>" ||
                //       editorValue === "<p><br></p>" ||
                //       editorValue == ""
                //       ? Promise.reject("Body is required")
                //       : Promise.resolve();
                //   }
                // },
              },
            ]}
          >
            {isRichEditor ? (
              <TextRichEditor
                value={editorValue}
                onChange={setEditorValue}
                placeholder="Enter email body"
              />
            ) : (
             (
                <HTMLRenderer htmlcode={form.getFieldValue("body")} setEditorValue={(v)=> form.setFieldsValue({ body: v })} />
              )
            )}

          </Form.Item>


          <Form.Item
            label="Footer"
            name="footer"
            rules={[{ required: false, message: "" }]}
          >
            <Input.TextArea rows={2} placeholder="Enter email footer body" />
          </Form.Item>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                disableElevation
                className="px-4"
                size="large"
                type="submit"
                variant="contained"
                color="primary"
              >
                {loadingBtn ? 'Processing...' : (data ? "Update" : "Add")}
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(CreateEditEmailTemplate);